// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__v-_aX","inputWrap":"CustomTip_inputWrap__2ORhF"};